* {
  box-sizing: border-box;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    height: 400px;
    align-items: stretch;
  }
}
